import DashboardLayout from "@/src/components/layout/DashboardLayout";
import { facilitiesApiService } from "@/src/lib/api-services/facilitiesApiServices";
import BannerImage from "@/src/components/common/bannerImage";
import FacilitiesNearYou from "@/src/modules/facilities/facilitiesNearYou";
import CommonlyBookedTest from "@/src/modules/facilities/commonlyBookedTest";
import Carousel from "@/src/components/common/carousel";
import FindTestByFacility from "../../src/modules/facilities/findTest";
import Link from "next/link";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";

// -------------------------------------------------------------------

FaciliteDetail.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

function FaciliteDetail({ data }) {
    const isMobile = useBreakpoint("sm");

    const facilitiesData = data;
    const facilityBannerImage = facilitiesData?.bannerImage || null;
    const facilityBannerImageResponsive =
        facilitiesData?.bannerResponsiveImage || null;

    return (
        <>
            <div className="bg-gray-100">
                <div className="relative">
                    <BannerImage
                        image={`${isMobile
                            ? facilityBannerImageResponsive
                            : facilityBannerImage
                            }`}
                        title={
                            facilitiesData?.bannerImageAlt ||
                            facilitiesData?.categoryName
                        }
                    />
                </div>
                <div className="md:py-8 py-4 max-w-6xl mx-auto px-3 md:px-0">
                    <div className="bg-white md:p-6 p-3 shadow-md rounded-lg">
                        <h1 className="text-xl md:text-2xl text-black font-bold mb-2">
                            {facilitiesData?.categoryName}
                        </h1>

                        <div
                            className="text-slate-800 text-sm"
                            dangerouslySetInnerHTML={{
                                __html: facilitiesData?.htmlTop,
                            }}
                        ></div>
                    </div>

                    <FindTestByFacility facilitiesData={facilitiesData} />

                    <div className="bg-white shadow-md rounded-lg">
                        <p className="bg-primary md:p-6 p-3 md:text-2xl font-bold rounded-tl-lg rounded-tr-lg text-white">{`${facilitiesData?.categoryName} Facility Near You`}</p>
                        <div>
                            {facilitiesData?.taggedCentres?.length > 0 &&
                                facilitiesData?.taggedCentres.map(
                                    (item, index) => (
                                        <FacilitiesNearYou
                                            key={item.state}
                                            item={item}
                                            index={index}
                                        />
                                    )
                                )}
                        </div>
                    </div>

                    <div>
                        <div className="md:mt-10 mt-4 md:mb-6 mb-4 flex justify-between items-center flex-row">
                            <h2 className="md:text-2xl text-base font-bold text-black">
                                Commonly Booked Tests
                            </h2>

                            <Link
                                className="text-primary uppercase cursor-pointer border border-solid border-primary md:px-6 px-4 md:py-2.5 py-2 rounded-xs font-semibold text-sm hover:bg-primary hover:text-white transition-all duration-300"
                                href="/find-a-test"
                            >
                                View ALL
                            </Link>
                        </div>

                        {facilitiesData?.taggedProducts?.length > 0 && (
                            <Carousel
                                settings={{
                                    dots: false,
                                    autoplay: true,
                                    speed: 700,
                                    slidesToShow: 3,
                                    slidesToScroll: 2,
                                    // centerMode: true,
                                    responsive: [
                                        {
                                            breakpoint: 600,
                                            settings: {
                                                slidesToShow: 1,
                                            },
                                        },
                                    ],
                                }}
                            >
                                {facilitiesData?.taggedProducts.map(
                                    (item, index) => (
                                        <CommonlyBookedTest
                                            key={index}
                                            row={item}
                                            urlSlug={facilitiesData?.urlSlug}
                                        />
                                    )
                                )}
                            </Carousel>
                        )}
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-lg md:my-0 my-3">
                        <div
                            className="text-slate-800 text-sm paragraph__setting"
                            dangerouslySetInnerHTML={{
                                __html: facilitiesData?.htmlBottom,
                            }}
                        ></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FaciliteDetail;

// This ensures that the page is server-side rendered
export async function getServerSideProps(context) {
    const slug = context.query.slug;
    let data = null;
    // Fetching the specialization data (you can modify this as needed)
    try {
        const response = await facilitiesApiService.getFacilitiesDetails(slug);
        data = response?.data?.[0];
    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        };
    }
    return {
        props: {
            data: { ...data, routerPath: `facilities/${slug}` },
        },
    };
}
